<template>
  <v-layout row wrap>
    <v-flex v-if="seOOB && seOOB.photos" xs12 class="galery">
      <v-card>
        <v-card-title primary-title class="py-2">
          <v-toolbar-title>{{ $t("view.operativos.seOOB.photos") }}</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="view.elem.showGalery = !view.elem.showGalery">
            <v-icon>{{ view.elem.showGalery ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-expand-transition>
          <v-card-text>
            <v-layout row wrap>
              <v-flex v-for="photo in seOOB.photos" :key="photo[0]" xs6 sm4 md3 lg2>
                <v-card outlined color="#e6e6e6">
                  <v-img :src="`${baseUrl}/api/imageResources/path/${photo[4]}/${photo[0]}/${photo[3]}`" aspect-ratio="1" class="grey lighten-2" @click="expand(photo)" />
                  <v-card-title>
                    <v-toolbar-title class="imagetext">{{ `${photo[0]}.${photo[3]}` }}</v-toolbar-title>
                    <v-spacer />
                    <v-btn icon small class="btn_tippy" :title="$t('view.commons.download')" @click="download(photo)">
                      <v-icon small>fa-download</v-icon>
                    </v-btn>
                    <v-btn icon small class="btn_tippy" :title="$t('view.commons.delete')" @click="remove(photo)">
                      <v-icon small>fa-trash-alt</v-icon>
                    </v-btn>
                  </v-card-title>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-expand-transition>
      </v-card>
    </v-flex>

    <v-dialog v-model="overlay" max-width="800px" eager>
      <v-card class="overlay">
        <v-card-title primary-title class="py-3 px-4 card_title">
          <v-spacer />
          <v-btn icon class="btn_tippy" :title="$t('view.commons.close')" @click="overlay = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-img :src="overlayimg" aspect-ratio="1" contain class="grey lighten-2" />
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import tippy from "tippy.js";

export default {
  name: "FiltersModule"
  , props: {
    seOOB: {
      default: null
      , type: Object
    }
  }
  , data() {
    return {
      baseUrl: globalThis.location.origin
      , overlay: false
      , overlayimg: ""
      , view: { elem: { showGalery: true } }
    };
  }
  , created() {
    this.$nextTick(() => tippy(".btn_tippy", { arrow: true, size: "large", animation: "scale", placement: "top" }));
  }
  , methods: {
    expand(photo) {
      this.overlayimg = `${this.baseUrl}/api/imageResources/path/${photo[4]}/${photo[0]}/${photo[3]}`;
      this.overlay = true;
    }
    , async download(photo) {
      try {
        const uri = `${this.baseUrl}/api/imageResources/path/${photo[4]}/${photo[0]}/${photo[3]}`;
        const url = globalThis.URL.createObjectURL(await fetch(uri).then((res) => res.blob()));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", photo[0]); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", "Error al descargar archivo");
        console.error(error);
      }
    }
    , remove(photo) {
      const photostr = photo.join(":");
      const photosstr = this.seOOB.photos.map((item) => item.join(":"));
      const newphotosstr = photosstr.filter((value) => value != photostr);
      const newphotosobj = newphotosstr.map((item) => item.split(":"));
      this.$emit("removePhoto", newphotosobj);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.galery {
  margin-bottom: 200px;
}

.galery .imagetext {
  font-size: small;
}

.overlay .card_title {
  position: absolute;
  z-index: 1;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/operativos/seOOB/Gallery.vue